// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".calendar{background:var(--q4s-white);display:flex;flex-direction:column}.we-calendar-header div{display:flex;justify-content:space-between}.we-calendar-week{display:grid;grid-template-columns:repeat(7,1fr);gap:0;height:27px;color:var(--q4s-neutral-500);border-bottom:1px solid var(--q4s-neutral-200)}.we-calendar-week .we-calendar-week__item{text-align:center}", ""]);
// Exports
module.exports = exports;
